<template>
	<AppDialog :dialogName="dialogName" width="630">
		<div class="content-wrapper px-9 pt-8 pb-5 display-flex flex-column flex-justify-space-between">
			<div class="display-flex flex-column">
				<div class="mb-7">
					<h2>Move feature to...</h2>
					<div class="width-100 display-flex flex-column mt-8">
						<h3>Destination Space</h3>
						<ProjectSelectDataProvider
							v-model="selectedProjectId"
							:filterOutIds="[...privateProjects, preSelectedProject]"
							class="width-100"
							:permission="CHANGE_WORKFLOWS_PERMISSION"
						/>
					</div>
				</div>
				<template v-if="isSelectedProjectWorkspaceProject">
					<span class="display-flex flex-row flex-align-center">
						<h3 class="bold">{{ selectedProject.title }}</h3>
						<h3 class="reg ml-1">is a shared space</h3></span
					>
					<h4 class="reg">
						Moving features from your personal space to a shared space is a one way ticket - features cannot be moved back to your personal
						space.
					</h4>
					<AppCheckbox :isOn.sync="allowMoveToWorkspaceProject" label="I understand that this is a one way ticket" />
				</template>
				<template v-else-if="!allowedToMoveToThisProject">
					<span class="display-flex flex-row flex-align-center">
						<h3 class="bold">{{ selectedProject.title }}</h3>
						<h3 class="reg ml-1">is a space which you do not have full access to, and so can not move your feature.</h3></span
					>
				</template>
			</div>
			<div class="flex-row flex-end--center">
				<AnemicButton class="cancel-button mr-2" @click="close">Cancel</AnemicButton>
				<PrimaryButton
					@click="doAction"
					class="yes-button"
					:disabled="
						!selectedProjectId || !allowedToMoveToThisProject || (!allowMoveToWorkspaceProject && isSelectedProjectWorkspaceProject)
					"
				>
					Move feature
				</PrimaryButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getProject, projectHasPermission } from '@/store/modules/projects/getters';
import ProjectsService from '@/utils/projects-service';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
import { projectsList } from '@/store/modules/projects/getters';
import ProjectSelectDataProvider from '@/components/Project/ProjectSelect/ProjectSelectDataProvider.vue';
export default {
	name: 'MoveProjectDialog',
	props: {
		preSelectedProject: { type: Number },
		dialogPromiseHandlers: { type: Object },
	},
	components: { AppDialog, ProjectSelectDataProvider },
	methods: {
		close() {
			AppDialogManagerService.closeCurrentDialog();
		},
		doAction() {
			this.dialogPromiseHandlers.resolve(this.selectedProjectId);
			this.close();
		},
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ getProject, projectsList, projectHasPermission }),
		selectedProject() {
			return this.getProject(this.selectedProjectId);
		},
		preSelectedProjectObject() {
			return this.getProject(this.preSelectedProject);
		},
		isSelectedProjectWorkspaceProject() {
			return ProjectsService.isWorkspaceProject(this.selectedProject) && ProjectsService.isPersonalProject(this.preSelectedProjectObject);
		},
		allowedToMoveToThisProject() {
			if (!this.selectedProjectId) {
				return true;
			}
			return this.projectHasPermission(this.selectedProjectId, ProjectPermissions.ChangeSettings);
		},
		privateProjects() {
			return this.projectsList.filter((p) => ProjectsService.isMyPersonalProject(p, this.user)).map((p) => p.id);
		},
	},
	data: () => ({
		dialogName: 'MoveProjectDialog',
		selectedProjectId: null,
		allowMoveToWorkspaceProject: false,
		CHANGE_WORKFLOWS_PERMISSION: ProjectPermissions.ChangeWorkflows,
	}),
};
</script>

<style scoped lang="scss">
.content-wrapper {
	height: 560px;
}
.footer-button {
	width: 127px !important;
	height: 45px !important;
	font-size: 14px !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
}
.cancel-button {
	@extend .footer-button;
	color: #5555f2 !important;
	background: #ffffff !important;
	border: 1px solid #5555f2 !important;
}
.yes-button {
	@extend .footer-button;
	color: #ffffff !important;
	background: #5555f2 !important;
}
::v-deep {
	.auto-complete-container {
		width: 100%;
	}
}
</style>
